interface ParsedName {
    firstName: string;
    lastName: string;
}

export function parseFullName(fullName: string): ParsedName {
    const trimmedName = fullName?.trim() ?? '';
    const nameParts = trimmedName.split(' ').filter(part => part.length > 0);

    switch (nameParts.length) {
        case 0:
            return { firstName: '', lastName: '' };
        case 1:
            return { firstName: '', lastName: nameParts[0] };
        default:
            return {
                firstName: nameParts[0],
                lastName: nameParts.slice(1).join(' '),
            };
    }
}
